<template>
  <div v-if="audioDoc" :style="{ color: '#07f' }">
    <br /><br />
    <br /><br />
    ==== &nbsp; &nbsp; &nbsp;
    {{ audioPath }}
    &nbsp; &nbsp; &nbsp; ====
    <br /><br />
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue';
import useAudio from '../stores/useAudio';
import bugAlert from '../lib/bugAlert';

const props = defineProps<{
  name: string;
}>();

const hasAudio = inject('hasAudio');
const audioDoc = inject('audioDoc');
const wordDoc = inject('wordDoc');
const sectionId = inject('sectionId') as string;
const { getAudioFilename } = useAudio();
const audioPath = computed(() => getAudioFilename(props.name));

if (
  !audioDoc &&
  !wordDoc.value &&
  hasAudio.value &&
  audioPath.value?.includes('undefined')
) {
  bugAlert(
    `Audio path contains 'undefined': Does the screen need an ID?\n\nSection: #${sectionId}\n\nAudio: ${audioPath.value}`
  );
}
</script>
